import type { Guide } from '../../types';
import asthmaReview from '../asthmaReview';

export default (async args => {
  // TODO we need to implement this. For now its the same guide.
  return await asthmaReview(args);
}: Guide);
